export default __webpack_public_path__ + "static/media/Binary Tree Visual.494edefc.svg";